import { getOrdinalSuffix } from '@noths/polaris-client-utils';

export const getFormattedDeliveryDate = (date: string) => {
  const dateObj = new Date(date);

  const dayName = new Intl.DateTimeFormat('en-GB', { weekday: 'short' }).format(dateObj);
  const monthName = new Intl.DateTimeFormat('en-GB', { month: 'short' }).format(dateObj);
  const dayOfMonth = dateObj.getDate();

  return `${dayName} ${dayOfMonth}${getOrdinalSuffix(dayOfMonth)} ${monthName}`;
};
